// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"53":"c28cee42","283":"2173fd26","407":"483013d3","497":"769a6a6c","575":"54ea4068"}[chunkId] + ".chunk.js";
};